// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1hHLX","dragIcon":"Choice_dragIcon__1AYdv","left":"Choice_left__2AF_3","input":"Choice_input__af_8R"};